import { Link } from '@mui/material';
import Image from 'next/image';
import { ClientSafeTenantConfig } from 'server/config-cache/types';

type Props = Pick<
  ClientSafeTenantConfig['navBar'],
  'logoLinkUrl' | 'logoImgUrl'
>;

/**
 * Configurable logo for header. Can be link based on logoLinkUrl value.
 *
 * Note we're using a classic anchor tag rather than next/router link, as next/router is only for
 * routes internal to this app, and its very likely that the link will point to a page served by
 * another app (at least for time being)
 *
 * Potential optimization would be to indicate in the config whether this an internal or external link.
 *
 * @todo better handling width / height; these are from Territory logo
 */
const NavBarLogo: React.FC<Props> = ({ logoLinkUrl, logoImgUrl }) => {
  return (
    //if logoLinkUrl is left undefined for a tenant, logo just won't function as a link.
    <Link href={logoLinkUrl} sx={{ display: 'flex', justifyContent: 'center' }}>
      <Image
        src={logoImgUrl}
        alt="logo"
        width="128"
        height="35"
        draggable={false}
        priority
      />
    </Link>
  );
};

export default NavBarLogo;
